import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { ProjectNanoID } from '../../../../../main/projects/projectsTypes';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTaskItemsValue,
  UniversalFilterTaskItemsModes,
  UniversalFilterTaskItemsOnChange
} from './UniversalFilterTaskItems.types';

import { useUniversalFilterTaskItems } from './hooks/useUniversalFilterTaskItems';

import { GroupedItemsMultiSelect } from '../../../../../main/groupedItems/helpers/GroupedItemsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

import { GroupedItemCache } from '../../../../../main/groupedItems/GroupedItemCache';
import { InvoiceStatuses } from '../../../../../main/invoices/invoicesTypes';

interface UniversalFilterTaskItemsProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTaskItemsValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterTaskItemsOnChange;
  projectNanoId?: ProjectNanoID;
}

function UniversalFilterTaskItems({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange,
  projectNanoId
}: UniversalFilterTaskItemsProps) {
  const { modeOptions, filterState, handleModeChange, handleTagIdsChange } =
    useUniversalFilterTaskItems({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterTaskItemsModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [UniversalFilterTaskItemsModes.CONTAINS_ALL_OF],
        filterState.mode
      ) && projectNanoId ? (
        <GroupedItemsMultiSelect
          key={filterState.mode}
          value={filterState.itemNames || []}
          autoFocus={autoFocus}
          onChange={handleTagIdsChange}
          cacheKey={GroupedItemCache.projectGroupedItemsCacheKey(projectNanoId)}
          initialFilters={{
            invoiceStatus: {
              notIn: [InvoiceStatuses.CANCELED, InvoiceStatuses.VOID]
            },
            projectNanoId: {
              eq: projectNanoId
            }
          }}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterTaskItems;
